"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMySubscriptions = void 0;
var React = __importStar(require("react"));
var IconMySubscriptions = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20.1328,13.5908 C20.2878,13.4358 20.3538,13.1848 20.1988,13.0298 C20.0438,12.8758 19.7268,12.9418 19.5718,13.0958 L16.9198,15.6938 L16.4398,14.6578 C16.3258,14.4708 16.0828,14.4108 15.8958,14.5248 C15.7088,14.6378 15.6488,14.8808 15.7618,15.0688 L16.5028,16.8668 C16.5658,16.9708 16.6738,17.0398 16.7938,17.0548 C16.8108,17.0568 16.8258,17.0578 16.8418,17.0578 C16.9458,17.0578 17.0478,17.0168 17.1218,16.9418 L20.1328,13.5908 Z M17.9958,10.9998 C20.2048,10.9998 21.9958,12.7908 21.9958,14.9998 C21.9958,17.2088 20.2048,18.9998 17.9958,18.9998 C15.7868,18.9998 13.9958,17.2088 13.9958,14.9998 C13.9958,12.7908 15.7868,10.9998 17.9958,10.9998 Z M4.5,4 C4.224,4 4,4.224 4,4.5 L4,8 L18,8 L18,4.5 C18,4.224 17.776,4 17.5,4 L15,4 L15,5 C15,5.276 14.776,5.5 14.5,5.5 C14.224,5.5 14,5.276 14,5 L14,4 L8,4 L8,5 C8,5.276 7.776,5.5 7.5,5.5 C7.224,5.5 7,5.276 7,5 L7,4 L4.5,4 Z M18.5,19.5 C18.776,19.5 19,19.724 19,20 L19,20.5 C19,21.327 18.327,22 17.5,22 L4.5,22 C3.673,22 3,21.327 3,20.5 L3,4.5 C3,3.673 3.673,3 4.5,3 L7,3 L7,2 C7,1.724 7.224,1.5 7.5,1.5 C7.776,1.5 8,1.724 8,2 L8,3 L14,3 L14,2 C14,1.724 14.224,1.5 14.5,1.5 C14.776,1.5 15,1.724 15,2 L15,3 L17.5,3 C18.327,3 19,3.673 19,4.5 L19,10 C19,10.277 18.776,10.5 18.5,10.5 C18.224,10.5 18,10.277 18,10 L18,9 L4,9 L4,20.5 C4,20.776 4.224,21 4.5,21 L17.5,21 C17.776,21 18,20.776 18,20.5 L18,20 C18,19.724 18.224,19.5 18.5,19.5 Z M7,13 L7,12 L13,12 L13,13 L7,13 Z M7,18 L7,17 L13,17 L13,18 L7,18 Z" }))); };
exports.IconMySubscriptions = IconMySubscriptions;
exports.IconMySubscriptions.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMySubscriptions;
